/**
 * created by tian ruo jun
 * 选题统计
 */
import React, {Component} from 'react';
import {Pagination, message} from 'antd';
import MyTable from "../component/MyTable";
import BseTitle from "../../components/bseTitle/BseTitle";
import {HEADER_HEIGHT} from '../../../constants'
import '../component/style/MyTable.css'
import {getTopicSelectionResult} from '../../../actions/choiceStatistical';
import {applicationName} from "../../../utils";

export default class ChoiceStatistical extends Component {
  static defaultProps = {};
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {
      tabKey: '1',

      count:{
        '按已提交数排序': 'submitCount',
        '按已采用数排序': 'useCount',
        '按已弃用数排序': 'deprecatedCount',
      }, // 排序规则

      // 按单位搜索数据
      params1:{
        a:1,
        start: 1,
        size: 10,
        startDate: '',
        endDate: '',
        queryStr:'',
        orderCondition:'submitCount',
      },

      // 按个人搜索数据
      params2:{
        a:2,
        start: 1,
        size: 10,
        startDate: '',
        endDate: '',
        queryStr:'',
        orderCondition:'submitCount',
      },

      // 按单位获取到的数据
      data1:{
        dataSource:[], // 表数据
        total:0,// 数据总条数
      },

      // 按个人获取到的数据
      data2:{
        dataSource:[], // 表数据
        total:0,// 数据总条数
      },

      // 按单位表格表头
      columns1:[
        {
          title: '姓名',
          dataIndex: 'tsCreateName',
          key: 'tsCreateName',
          align: 'center',
          ellipsis: true,
        },
        {
          title: '已提交',
          dataIndex: 'submitCount',
          key: 'submitCount',
          align: 'center',
          render: (value) => {
            return value || 0
          }
        },
        {
          title: '已采用',
          dataIndex: 'useCount',
          key: 'useCount',
          align: 'center',
          render: (value) => {
            return value || 0
          }
        },
        {
          title: '已弃用',
          dataIndex: 'deprecatedCount',
          key: 'deprecatedCount',
          align: 'center',
          render: (value) => {
            return value || 0
          }
        }
      ],

      // 按单位表格表头
      columns2:[
        {
          title: '单位',
          dataIndex: 'deptName',
          key: 'deptName',
          align: 'center',
          ellipsis: true,
        },
        {
          title: '姓名',
          dataIndex: 'submitterName',
          key: 'submitterName',
          align: 'center',
          ellipsis: true,
        },
        {
          title: '已提交',
          dataIndex: 'submitCount',
          key: 'submitCount',
          align: 'center'
        },
        {
          title: '已采用',
          dataIndex: 'useCount',
          key: 'useCount',
          align: 'center'
        },
        {
          title: '已弃用',
          dataIndex: 'deprecatedCount',
          key: 'deprecatedCount',
          align: 'center'
        }
      ],
    }
  }

  componentWillMount() {
  }

  componentDidMount() {
    // this.getDataStatus()
  }

  // 获取表格数据
  getDataStatus = () => {
    if(this.state.tabKey === '1') {
      console.log(this.state.params1,'准备调接口')
      getTopicSelectionResult(this.state.params1,(res)=>{
        if(res){
          this.state.data1.total = res.count;
          if(res.data) {
            this.state.data1.dataSource = res.data;
          }
          this.setState({})
        }
      })
    } else {
      // getNewsCluePersonResult(this.state.params2,(res)=>{
      //   if(res){
      //     this.state.data2.total = res.count;
      //     if(res.data) {
      //       this.state.data2.dataSource = res.data;
      //     }
      //     this.setState({})
      //   }
      // })
    }
  };

  // tab栏切换
  // tabChange = (key) => {
  //   this.state.tabKey = key;
  //   this.setState({});
  //   this.getDataStatus();
  // };

  // 选择排序方式
  mySelect = (count) => {
    if(this.state.tabKey === '1') {
      this.state.params1.orderCondition = this.state.count[count];
      this.state.params1.start = 1;
      this.state.params1.size = 10;
    } else {
      this.state.params2.orderCondition = this.state.count[count];
      this.state.params2.start = 1;
      this.state.params2.size = 10;
    }
    this.setState({},()=>{
      this.getDataStatus()
    })
  };

  // 搜索功能
  mySearch = (query) => {
    if(this.state.tabKey === '1') {
      this.state.params1.queryStr = query.trim();
      this.state.params1.start = 1;
      this.state.params1.size = 10;
    } else {
      this.state.params2.queryStr = query.trim();
      this.state.params2.start = 1;
      this.state.params2.size = 10;
    }
    this.setState({},()=>{
      this.getDataStatus()
    })
  };

  // 导出功能
  myExport = () => {
    if(this.state.tabKey === '1') {
      if(!this.state.data1.total) return message.error('数据表为空，无法导出！');
      let params1 = this.state.params1;
      //getExport(params1)
      //window.open("/cm-sites-" + applicationName() + '/exceptResult/exportNewsClueDeptResult'+'?queryStr='+params1.queryStr+'&startDate='+params1.startDate+'&endDate='+params1.endDate+'&orderCondition='+params1.orderCondition)
      window.location.href = "/cm-sites-" + applicationName() + '/exceptResult/exportTopicSelectionResult'+'?queryStr='+params1.queryStr+'&startDate='+params1.startDate+'&endDate='+params1.endDate+'&orderCondition='+params1.orderCondition;
    } else {
      let params2 = this.state.params2;
      //window.location.href = "/cm-sites-" + applicationName() + '/exceptResult/exportNewsCluePersonResult'+'?queryStr='+params2.queryStr+'&startDate='+params2.startDate+'&endDate='+params2.endDate+'&orderCondition='+params2.orderCondition;
    }
  };

  // 日期选择
  datetime = (start,end) => {
    console.log(start,end,'时间组件启动');
    if(this.state.tabKey === '1') {
      this.state.params1.startDate = start;
      this.state.params1.endDate = end;
      this.state.params1.start = 1;
      this.state.params1.size = 10;
    } else {
      this.state.params2.startDate = start;
      this.state.params2.endDate = end;
      this.state.params2.start = 1;
      this.state.params2.size = 10;
    }
    this.setState({},()=>{
      this.getDataStatus()
    })
  };

  // 页码及size改变
  pageChange = (start,size) => {
    console.log(start,size,'页码改变');
    if(this.state.tabKey === '1') {
      this.state.params1.start = start;
      this.state.params1.size = size;
    } else {
      this.state.params2.start = start;
      this.state.params2.size = size;
    }
    this.setState({},()=>{
      this.getDataStatus()
    })
  };

  render() {
    let {tabKey,params1,params2,data1,data2,count,columns1,columns2} = this.state;

    let mySelectOptions = [];
    for (let i in count) {
      mySelectOptions.push(i);
    }

    let height = window.innerHeight - HEADER_HEIGHT;
    let tableHeight = height - 28 - 32 - 100;// title58 tab40h/36m fenye32/100

    return (
        <div style={{height: height,background:'#fff'}}>
          {/*<BseTitle title={'选题统计'}/>*/}
          <div style={{height:28}}></div>
          <div className={'tabBox'} style={{height:tableHeight}}>
                  <MyTable
                      tabKey={tabKey}
                      tableHeight={tableHeight}
                      datetimeList={['本周', '上周', '本月', '上月']}
                      columns={columns1}
                      dataSource={data1.dataSource}
                      placeholder={'请输入姓名'}
                      mySelect={this.mySelect}
                      mySearch={this.mySearch}
                      myExport={this.myExport}
                      datetime={this.datetime}
                      mySelectOptions={mySelectOptions}
                  />
          </div>
          {/*高32，上下边距50*/}
          <div style={{display: "flex", justifyContent: "space-between", margin: '50px 20px'}}>
            <div>共搜索到 {tabKey === '1' ? data1.total :data2.total } 条数据</div>
            <Pagination
                showQuickJumper
                showSizeChanger
                defaultCurrent={1}
                defaultPageSize={10}
                current={tabKey === '1' ? params1.start :params2.start }
                pageSize={tabKey === '1' ? params1.size :params2.size }
                total={tabKey === '1' ? data1.total :data2.total }
                onChange={this.pageChange} //页码改变时回调
                onShowSizeChange={this.pageChange} //每页条数改变回调
            />
          </div>
        </div>
    )
  }

}